import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'wouter';

export const AppTitle = memo(() => {
  const { t } = useTranslation();
  const [location] = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    if (location === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Below md the wordmark collided with the currency switcher and the signed-in
  // controls (360-430px); the badge alone keeps the home link there.
  return (
    <Link
      href="/"
      aria-label="DPIN Prediction Market"
      className="flex items-center space-x-2 whitespace-nowrap shrink-0"
      onClick={handleClick}
    >
      <img src="/img/dpin-badge.png" alt="DPIN" width={24} height={24} className="size-6 lg:size-8" />
      <span
        className="hidden md:inline text-lg lg:text-xl font-bold text-foreground tracking-wide"
        style={{ fontFamily: "'Rajdhani', sans-serif" }}
      >
        DPIN Predict
      </span>
      <h1 className="hidden">{t('title')}</h1>
    </Link>
  );
});

AppTitle.displayName = 'AppTitle';
